import { FC } from "react";
import { IconPropsType } from ".";

export const ReservationRequest: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66634 1.00004C1.74587 1.00004 0.999674 1.74623 0.999674 2.66671V13.3334C0.999674 14.2538 1.74587 15 2.66634 15H9.99967C10.9201 15 11.6663 14.2538 11.6663 13.3334V8.00004H12.333V13.3334C12.333 14.622 11.2883 15.6667 9.99967 15.6667H2.66634C1.37768 15.6667 0.333008 14.622 0.333008 13.3334V2.66671C0.333008 1.37804 1.37768 0.333374 2.66634 0.333374H7.46634V1.00004H2.66634Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30621 7.72739C6.24319 7.28625 6.00421 6.78553 5.57565 6.35696C5.14708 5.9284 4.64636 5.68943 4.20523 5.62641C3.76434 5.56342 3.42751 5.67668 3.21863 5.88556C3.00975 6.09444 2.89649 6.43128 2.95947 6.87216C3.02249 7.3133 3.26147 7.81402 3.69003 8.24258C4.11859 8.67115 4.61932 8.91012 5.06045 8.97314C5.50134 9.03612 5.83817 8.92287 6.04705 8.71399C6.25593 8.50511 6.36919 8.16827 6.30621 7.72739ZM6.51846 9.18539C7.29951 8.40434 7.08845 6.92696 6.04705 5.88556C5.00565 4.84416 3.52827 4.63311 2.74722 5.41416C1.96617 6.1952 2.17723 7.67259 3.21863 8.71399C4.26002 9.75539 5.73741 9.96644 6.51846 9.18539Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6396 11.7781L6.04688 9.18542L6.51828 8.71402L9.111 11.3067L8.6396 11.7781Z"
        fill={props.color}
      />
      <path
        d="M7.93234 11.5424C7.67199 11.2821 7.67199 10.86 7.93234 10.5996C8.19269 10.3393 8.6148 10.3393 8.87515 10.5996L9.81796 11.5424C10.0783 11.8028 10.0783 12.2249 9.81796 12.4853C9.55761 12.7456 9.1355 12.7456 8.87515 12.4853L7.93234 11.5424Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6663 6.66663C12.1391 6.66663 13.333 5.47272 13.333 3.99996C13.333 2.5272 12.1391 1.33329 10.6663 1.33329C9.19358 1.33329 7.99967 2.5272 7.99967 3.99996C7.99967 5.47272 9.19358 6.66663 10.6663 6.66663ZM10.6663 7.33329C12.5073 7.33329 13.9997 5.84091 13.9997 3.99996C13.9997 2.15901 12.5073 0.666626 10.6663 0.666626C8.82539 0.666626 7.33301 2.15901 7.33301 3.99996C7.33301 5.84091 8.82539 7.33329 10.6663 7.33329Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.333 3.86193V2H10.9997V4.13807L9.90207 5.2357L9.43066 4.7643L10.333 3.86193Z"
        fill={props.color}
      />
    </svg>
  );
};
